import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BuyflowSearchBarComponent } from './buyflow-search-bar.component';
import { PlacesAutocompleteModule } from '../../shared/places-autocomplete/places-autocomplete.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { MatRadioModule } from '@angular/material/radio';
import { BuyflowFeaturedLocationsModule } from '../../shared/buyflow/buyflow-featured-locations/buyflow-featured-locations.module';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';

@NgModule({
  declarations: [BuyflowSearchBarComponent],
  exports: [BuyflowSearchBarComponent],
  imports: [
    CommonModule,
    PlacesAutocompleteModule,
    MatFormFieldModule,
    MatDatepickerModule,
    FormsModule,
    MatInputModule,
    SharedModule,
    MatRadioModule,
    MatIconModule,
    MatTabsModule,
    BuyflowFeaturedLocationsModule,
  ],
})
export class BuyflowSearchBarModule {}
